import request from "utils/request";
import { subDays, format, differenceInCalendarDays } from "date-fns";
import {
  fetchDatesSuccess,
  autoskip,
  markSuccess,
  unmarkSuccess,
  skipSuccess,
} from "actions/dates";
import { setFetchingHabits, processPendingActions } from "utils/pendingActions";
import {
  calculateNewStreaks,
  updateStreak,
  calculateGroupStats,
} from "actions/stats";
import constants from "common/constants";
import history from "utils/history";
import { hasPendingDataToSync } from "utils/network";
import { sendEvent } from "utils/events";

export function fetchHabitsSuccess(rows, habitsHash, groupsHash) {
  return {
    type: "FETCH_HABITS_SUCCESS",
    rows,
    habitsHash,
    groupsHash,
  };
}

export function fetchHabitSuccess(habit) {
  return {
    type: "FETCH_HABIT_SUCCESS",
    habit,
  };
}

export function addHabitSuccess(habit) {
  return {
    type: "ADD_HABIT_SUCCESS",
    habit,
  };
}

export function editHabitSuccess(habit) {
  return {
    type: "EDIT_HABIT_SUCCESS",
    habit,
  };
}

export function deleteHabitSuccess(habit_id) {
  return {
    type: "DELETE_HABIT_SUCCESS",
    habit_id,
  };
}

export function moveHabit(dragIndex, hoverIndex, dragHabit) {
  return {
    type: "MOVE_HABIT",
    dragIndex,
    hoverIndex,
    dragHabit,
  };
}

// Legacy Redux actions - keeping for compatibility but functionality moved to pendingActions module
export function fetchingHabits() {
  return {
    type: "FETCHING_HABITS",
  };
}

export function notFetchingHabits() {
  return {
    type: "NOT_FETCHING_HABITS",
  };
}

export function clearQueue() {
  return {
    type: "CLEAR_QUEUE",
  };
}

const findIndex = (row, state) => {
  return state.rows.findIndex((r) => {
    if (row.isGroup == r.isGroup && row.isHabit == r.isHabit && row.id == r.id)
      return r;
  });
};

export function moveRow({ rowFrom, rowTo, hoverGroupId }) {
  return async (dispatch, getState) => {
    try {
      let state = getState();

      let indexFrom = findIndex(rowFrom, state);
      let indexTo = findIndex(rowTo, state);

      const direction = indexFrom > indexTo ? "up" : "down";

      //console.log("direction", direction);

      let newGroupId;

      if (direction === "down") {
        if (rowTo.expanded) {
          newGroupId = rowTo.id;
        } else {
          newGroupId = rowTo.group_id;
        }
      } else {
        if (rowTo.isGroup) {
          newGroupId = null;
        } else {
          newGroupId = rowTo.group_id;
        }
      }

      //console.log("sort!", hoverGroupId, newGroupId, rowTo);

      if (
        !hoverGroupId &&
        rowTo.isGroup &&
        !rowTo.expanded &&
        indexTo > indexFrom
      ) {
        indexTo = indexTo + rowTo.numHabits;
      }

      if (rowFrom.isHabit && hoverGroupId) {
        // console.log('calc', indexTo, rowTo.numHabits);
        if (indexTo < indexFrom) indexTo = indexTo + (rowTo.numHabits || 0) + 1;
        else indexTo = indexTo + (rowTo.numHabits || 0);
      }

      if (rowFrom?.isHabit) {
        if (hoverGroupId) {
          console.log("CASE 0");

          dispatch(
            changeHabitGroup({
              habitId: rowFrom.id,
              from: rowFrom.group_id,
              to: hoverGroupId,
            })
          );

          if (indexFrom > indexTo) indexTo++;
        } else if (newGroupId !== rowFrom.group_id) {
          console.log("CASE 1", rowFrom.group_id, newGroupId);
          dispatch(
            changeHabitGroup({
              habitId: rowFrom.id,
              from: rowFrom.group_id,
              to: newGroupId,
            })
          );
        }

        if (indexFrom !== indexTo)
          dispatch({
            type: "MOVE_ROW",
            from: indexFrom,
            to: indexTo,
          });
      } else {
        const group = rowFrom;
        const newRows = [...state.rows];

        if (indexTo > indexFrom) {
          const diff = indexTo - indexFrom;
          const numExtraRows = diff - group.numHabits;

          for (let i = 0; i <= diff; i++) {
            const index = indexFrom + i;
            const currentRow = state.rows[index];

            if (
              i === 0 ||
              (currentRow.isHabit &&
                state.habitsEntities[currentRow.id].group_id === group.id)
            ) {
              newRows[index + numExtraRows] = currentRow;
            } else newRows[index - (group.numHabits + 1)] = currentRow;
          }
        } else {
          const diff = indexFrom - indexTo;

          for (let i = 0; i <= diff + group.numHabits; i++) {
            const index = indexFrom + group.numHabits - i;
            const currentRow = state.rows[index];

            if (
              (currentRow.isGroup && currentRow.id === group.id) ||
              (currentRow.isHabit &&
                state.habitsEntities[currentRow.id].group_id === group.id)
            ) {
              newRows[index - diff] = currentRow;
            } else newRows[index + group.numHabits + 1] = currentRow;
          }
        }

        dispatch({
          type: "SET_ROWS",
          rows: newRows,
        });
      }

      dispatch(sortRows());
    } catch (e) {
      console.log(e.stack);
    }
  };
}

export function initHabit(habit) {
  const newHabit = { ...habit };

  newHabit.currentStreak = 0;
  newHabit.longestStreak = 0;
  newHabit.weekCount = 0;
  newHabit.monthCount = 0;
  newHabit.yearCount = 0;
  newHabit.weekComplRate = 0;
  newHabit.monthComplRate = 0;
  newHabit.yearComplRate = 0;
  newHabit.totalCount = 0;
  newHabit.baseLongestStreak = 0;
  newHabit.baseCurrentStreak = 0;
  newHabit.baseYearCount = 0;
  newHabit.baseMonthCount = 0;
  newHabit.baseTotalCount = 0;
  newHabit.skipMonthCount = 0;
  newHabit.skipYearCount = 0;
  newHabit.monthBase = 0;
  newHabit.yearBase = 0;

  return newHabit;
}
//
export function createAutoSkips(habitId) {
  return async (dispatch, getState) => {
    const state = getState();
    const habits = state.rows
      .filter((row) => row.isHabit)
      .map((row) => state.habitsEntities[row.id]);

    const lastAction = new Date(state.user.last_action);
    let numDays = differenceInCalendarDays(new Date(), lastAction);
    const today = new Date();
    while (numDays >= 0) {
      const currentDate = subDays(today, numDays);
      const dateStr = format(currentDate, "YYYY-MM-DD");
      const dayName = format(currentDate, "dddd").toLowerCase();

      for (const habit of habits) {
        if (
          habit &&
          !habit[dayName] &&
          !(state.dates[habit.id] && state.dates[habit.id][dateStr])
        ) {
          dispatch(
            autoskip({
              date: dateStr,
              habit_id: habit.id,
              device: "web",
            })
          );
        }
      }

      numDays--;
    }
  };
}

export function fetchHabit({ userId, habitId }) {
  const baseDate = subDays(new Date(), constants.numDays);
  const formattedBaseDate = format(baseDate, "YYYY-MM-DD");

  return async (dispatch) => {
    try {
      setFetchingHabits(true);
      dispatch(fetchingHabits());

      const res = await request({
        url: `habitsV2?&base_date=${formattedBaseDate}&user_id=${userId}&habit_id=${habitId}`,
        method: "GET",
        preventSpam: true,
      });

      if (!res) {
        setFetchingHabits(false);
        return;
      }

      const { habitsArray, datesHash } = res;

      const habit = habitsArray[0];
      const habitWithStats = calculateNewStreaks({
        dates: datesHash[habit.id],
        habit,
        baseDate: formattedBaseDate,
      });

      dispatch(
        fetchDatesSuccess({
          dates: datesHash,
          baseDate: formattedBaseDate,
          overwrite: false,
        })
      );
      dispatch(fetchHabitSuccess(habitWithStats));

      setFetchingHabits(false);
    } catch (e) {
      setFetchingHabits(false);
      history.replace("/");
    }
  };
}

export function fetchHabits() {
  return async (dispatch, getState) => {
    try {
      sendEvent("debug:fetchingstart", {
        pendingData: hasPendingDataToSync(),
      });
      if (hasPendingDataToSync()) return;

      setFetchingHabits(true);
      dispatch(fetchingHabits());

      const baseDate = subDays(new Date(), constants.numDays);
      const formattedBaseDate = format(baseDate, "YYYY-MM-DD");

      console.log("fetchingHabits!!", formattedBaseDate);

      const res = await request({
        url: `habitsV2?&base_date=${formattedBaseDate}`,
        method: "GET",
        action: "FETCH_HABITS",
        requiresAuth: true,
      });

      console.log("end fetchingHabits!!", formattedBaseDate);

      if (!res) {
        setFetchingHabits(false);
        dispatch({ type: "NOT_FETCHING_HABITS" });
        return;
      }

      let { habitsHash, datesHash, groupsHash, rows } = res;

      dispatch(
        fetchDatesSuccess({ dates: datesHash, baseDate: formattedBaseDate })
      );

      Object.values(habitsHash).forEach((habit) => {
        const habitWithStats = calculateNewStreaks({
          dates: datesHash[habit.id],
          habit,
          baseDate: formattedBaseDate,
        });
        habitsHash[habit.id] = habitWithStats;
      });

      dispatch(fetchHabitsSuccess(rows, habitsHash, groupsHash));

      Object.values(groupsHash).forEach((group) => {
        const groupWithStats = calculateGroupStats(group);
        groupsHash[group.id] = groupWithStats;
      });

      dispatch(fetchHabitsSuccess(rows, habitsHash, groupsHash));

      // Set fetching to false before processing pending actions
      setFetchingHabits(false);
      dispatch(notFetchingHabits());

      // Process any pending actions that occurred during the fetch
      processPendingActions(dispatch, getState);

      dispatch(createAutoSkips());
      dispatch({ type: "UPDATE_USER_LAST_ACTION" });
    } catch (e) {
      setFetchingHabits(false);
      console.log(e);
    }
  };
}

export function addHabit(habit) {
  return async (dispatch, getState) => {
    try {
      const newHabit = initHabit(habit);
      let state = getState();

      newHabit.id = Math.floor(1000000 + Math.random() * 9000000); // random tmp id
      newHabit.tmp = true;

      if (state.boardFilter.groupId) {
        const groupPosition = state.rows.findIndex(
          (row) => row.id.toString() === state.boardFilter.groupId.toString()
        );
        const group = state.groupsEntities[state.boardFilter.groupId];

        newHabit.position = groupPosition + group.numHabits + 1;

        dispatch(addHabitSuccess(newHabit));

        dispatch({
          type: "CHANGE_HABIT_GROUP",
          habitId: newHabit.id,
          to: state.boardFilter.groupId,
        });

        dispatch(sortRows());
      } else dispatch(addHabitSuccess(newHabit));

      sendEvent("action:newhabit");

      await request({
        url: "habits",
        method: "POST",
        action: "ADD_HABIT",
        body: newHabit,
        habitId: newHabit.id,
      });

      dispatch(createAutoSkips(newHabit.id));
    } catch (e) {}
  };
}

export function sortRows() {
  return async (dispatch, getState) => {
    const state = getState();

    sendEvent("action:sort");

    await request({
      url: "sortRows",
      method: "PUT",
      action: "SORT_ROWS",
      body: state.rows.map((row) => {
        if (row.isHabit)
          return { ...row, group_id: state.habitsEntities[row.id].group_id };
        return row;
      }),
    });
  };
}

export function editHabit(habit) {
  return async (dispatch, getState) => {
    try {
      let state = getState();
      state = getState();

      const oldHabit = state.habitsEntities[habit.id];

      if (oldHabit.archived && !habit.archived) {
        dispatch({
          type: "UNARCHIVE",
          id: habit.id,
        });
      }

      if (!oldHabit.archived && habit.archived) {
        dispatch({
          type: "ARCHIVE",
          id: habit.id,
        });
        if (habit.group_id) {
          dispatch(
            changeHabitGroup({
              habitId: habit.id,
              from: habit.group_id,
              to: null,
            })
          );
        }
        habit.group_id = null;
      }

      sendEvent("action:edithabit", {
        habitId: habit.id,
      });

      dispatch(editHabitSuccess(habit));
      dispatch(createAutoSkips(habit.id));

      if (
        oldHabit.color !== habit.color ||
        oldHabit.break_habit !== habit.break_habit
      )
        dispatch({
          type: "UPDATE_HABIT_COLOR",
          habit: habit,
        });

      await request({
        action: "EDIT_HABIT",
        url: "habits/" + habit.id,
        method: "PUT",
        body: habit,
        habitId: habit.id,
      });
    } catch (errors) {
      console.log("edit habit failed", errors);
      if (errors instanceof Error) {
        // sentry.captureException(errors);
      }
    }
  };
}

export function deleteHabit(habit_id) {
  return async (dispatch, getState) => {
    try {
      const state = getState();

      if (state.habitsEntities[habit_id].group_id) {
        dispatch({
          type: "REMOVE_HABIT_FROM_GROUP",
          groupId: state.habitsEntities[habit_id].group_id,
        });
      }
      dispatch(deleteHabitSuccess(habit_id));
      sendEvent("action:deletehabit", {
        habitId: habit_id,
      });
      await request({
        action: "DELETE_HABIT",
        url: "habits/" + habit_id,
        method: "DELETE",
        habitId: habit_id,
      });
    } catch (e) {
      if (e instanceof Error) {
        console.log("delete habit failed", e);
        // sentry.captureException(errors);
      }
    }
  };
}

export function changeHabitGroup({ habitId, from, to }) {
  return async (dispatch, getState) => {
    try {
      // First dispatch the existing group change action
      dispatch({
        type: "CHANGE_HABIT_GROUP",
        habitId,
        from,
        to,
      });

      // Get updated state after group change
      const state = getState();

      // Recalculate stats for the source group if it exists
      if (from) {
        const fromGroup = state.groupsEntities[from];
        if (fromGroup) {
          const fromGroupWithStats = calculateGroupStats(fromGroup);
          dispatch({
            type: "EDIT_GROUP",
            group: fromGroupWithStats,
          });
        }
      }

      // Recalculate stats for the destination group if it exists
      if (to) {
        const toGroup = state.groupsEntities[to];
        if (toGroup) {
          const toGroupWithStats = calculateGroupStats(toGroup);
          dispatch({
            type: "EDIT_GROUP",
            group: toGroupWithStats,
          });
        }
      }
    } catch (e) {}
  };
}
